import React from 'react';
import { FormInput } from 'react-form';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

export default ( { field, ...rest } ) => {
  return (
    <FormInput field={field}>
      {( { setValue, getValue, setTouched } ) => {
        return(
          <Editor
            {...rest}
            editorState={getValue()}
            onEditorStateChange={val => setValue( val )}
            onBlur={() => setTouched()}
            wrapperClassName="wysiwyg-wrapper"
          />
        )
      }
      }
    </FormInput>
  )
}



// WEBPACK FOOTER //
// ./components/FormElements/Wysiwyg/index.js